import React from "react";
import { FaLinkedin } from "react-icons/fa";
import { leaders, advisoryBoard } from "../data/teamData";
import "./TeamStyle.css";

function Team() {
  return (
    <div className="team-container">
      <h1>Our Team</h1>
      <p>
        IndoDefTech is driven by leaders and advisors who bring deep experience,
        strategic insight, and a shared vision for innovation in defense and
        technology.
      </p>

      {/* ===== Leaders Section ===== */}
      <section className="team-section"> 
        <div className="team-grid">
          {leaders.map((member) => (
            <div className="team-card" key={member.id}>
              {member.image && (
                <img
                  src={member.image}
                  alt={member.name}
                  className="team-photo"
                />
              )}
              <h3>{member.name}</h3>
              <p className="team-role">{member.role}</p>
              
              

            </div>
          ))}
        </div>
      </section>

      {/* ===== Advisory Board Section ===== */}
      <section className="team-section w3-hide">
        <h2>Advisory Board</h2>
        <div className="team-grid">
          {advisoryBoard.map((member) => (
            <div className="team-card" key={member.id}>
              {member.image && (
                <img
                  src={member.image}
                  alt={member.name}
                  className="team-photo"
                />
              )}
              <h3>{member.name}</h3>
              <p className="team-role">{member.role}</p>
              {member.linkedin && (
                <a
                  href={member.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="linkedin-icon"
                >
                  <FaLinkedin />
                </a>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Team;
